(function() {
'use strict';

angular
    .module('core')
    .directive('contactForm', contactForm);

function contactForm(bookingService) {
    return {
        restrict: 'E',
        replace: false,
        transclude: true,
        scope: {
            contactDetail: '=',
            rootForm: '=',
            loggedInUser: '=',
            contactForm: '=',
            bookingTracker: '@',
            namePart: '@',
            signupPart: '@',
            emailPart: '@',
            isPostCodeRequired: '@',
            onNotYouClick: '&',
            enableEditEmailAlways: '@'
        },
        controller() {
            const cm = this;
            cm.form = cm.contactForm || cm.rootForm;

            cm.getContentUrl = function() {
                return `partials/home/contactdetailsform?bookingTracker=${cm.bookingTracker}`;
            };

            cm.agentMode = TRPCONFIG.Domain.isAgentMode;
            cm.showNamePart = cm.namePart === 'true';
            cm.showSignupPart = cm.signupPart === 'true';
            cm.showEmailPart = cm.emailPart === 'true';

            cm.adultTitles = bookingService.getAdultTitles();
        },
        controllerAs: 'cm',
        bindToController: true,
        template: '<div ng-include="cm.getContentUrl()"></div>'
    };
}
})();
